import { EWSS_GRADES } from "../constants/registerFilters";
import { getEwssGradeFromGameEntry } from "./ewssRetention";

const SINGLE_COUNT_CATEGORIES = new Set([
  "min-score-partie",
  "zamselly-score",
  "melitaea-score",
  "no-potion-key-score",
  "memory-score",
  "perfect-partie",
  "best-partie",
  "common-gem",
]);

function parseTrailingNumber(value) {
  const match = String(value || "").match(/(\d+)$/);
  return match ? Number(match[1]) : null;
}

export function getQuestObjectiveDisplayTarget(objective) {
  if (objective?.partieScore || SINGLE_COUNT_CATEGORIES.has(objective?.categoryId)) {
    return 1;
  }

  const progressTarget = Number(objective?.progress?.target);
  if (Number.isFinite(progressTarget) && progressTarget > 0) {
    return progressTarget;
  }

  const parsed = parseTrailingNumber(objective?.statId || objective?.id);
  return parsed != null ? parsed : 1;
}

export function formatQuestProgressLabel(objective) {
  const isCompleted = objective?.status === "completed";
  const target = getQuestObjectiveDisplayTarget(objective);

  if (objective?.categoryId === "reading") {
    const minutes = Number(objective?.progress?.target) || target;
    const current = isCompleted ? minutes : 0;
    return `${current} / ${minutes} min`;
  }

  if (objective?.categoryId === "training") {
    const sessions = Number(objective?.progress?.target) || target;
    const rawCurrent = Number(objective?.progress?.current) || 0;
    const current = isCompleted
      ? sessions
      : Math.min(Math.max(0, Math.round(rawCurrent)), sessions);
    return `${current} / ${sessions} session${sessions > 1 ? "s" : ""}`;
  }

  if (objective?.categoryId === "test-next-level") {
    const parties = Number(objective?.progress?.target) || target;
    const rawCurrent = Number(objective?.progress?.current) || 0;
    const current = isCompleted
      ? parties
      : Math.min(Math.max(0, Math.round(rawCurrent)), parties);
    return `${current} / ${parties} partie${parties > 1 ? "s" : ""}`;
  }

  if (objective?.partieScore || SINGLE_COUNT_CATEGORIES.has(objective?.categoryId)) {
    return `${isCompleted ? 1 : 0} / 1`;
  }

  const rawCurrent = Number(objective?.progress?.current) || 0;
  const current = isCompleted ? target : Math.min(Math.max(0, Math.round(rawCurrent)), target);
  return `${current} / ${target}`;
}

export function countGradeImprovementsFromInsights(wordInsights = []) {
  let count = 0;

  for (const insight of wordInsights) {
    const games = Array.isArray(insight?.last5Games) ? insight.last5Games : [];
    if (games.length < 2) continue;

    const newestGrade = getEwssGradeFromGameEntry(games[0]);
    const previousGrade = getEwssGradeFromGameEntry(games[1]);
    const newestIndex = EWSS_GRADES.indexOf(newestGrade);
    const previousIndex = EWSS_GRADES.indexOf(previousGrade);

    if (newestIndex >= 0 && previousIndex >= 0 && newestIndex < previousIndex) {
      count += 1;
    }
  }

  return count;
}

export async function fetchLastGameWordInsights() {
  const { API_URL } = await import("../config/api");
  const res = await fetch(`${API_URL}/mots-liste-detail?filter=lastGame`);
  const json = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(json.message || "Impossible de charger les insights de la dernière partie.");
  }

  return json.wordInsights ?? [];
}
